import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

import { getUser } from "../../helpers/services/UserServices";

export default (_props) => {
  console.log("PROPS", _props);
  const [props, setProps] = React.useState(_props);
  React.useEffect(() => {
    // if (
    //   props.defaultValue.first_name !== _props.defaultValue.first_name ||
    //   props.defaultValue.last_name !== _props.defaultValue.last_name
    // )
    setProps(_props);
  }, [_props]);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    console.log("Changing Props", props);
  }, [props]);
  const handleInputChange = (event, value) => {
    if (open) {
      value = value.trim();
      if (value.length > 1) {
        getUserName(value);
      }
    }
  };

  const getUserName = async (data) => {
    try {
      let result = await getUser(data);
      setOptions(result);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      {props && (
        <Autocomplete
          name="contactPerson"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          value={props.defaultValue}
          onInputChange={handleInputChange}
          onChange={(option, value) => {
            props.onValueChange(value);
          }}
          getOptionLabel={(option) =>
            option.first_name + " " + option.last_name
          }
          options={options}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ width: "300px" }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      )}
    </React.Fragment>
  );
};
